import * as React from 'react';
import SenderImageFull from './components/SenderImageFull';
import discardSenderImageOption from './actions/discardSenderImageOption';
import saveSenderImageOption, { onSenderImageToggle } from './actions/saveSenderImageOption';
import isSenderImageOptionDirty from './utils/isSenderImageOptionDirty';
import isSenderImageEnabled from './utils/isSenderImageEnabled';
var SenderImageOption = {
    key: 'senderImage',
    titleStringKey: 'optionTitle_senderImage',
    searchTermsStringKey: 'optionTitle_senderImage',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SenderImageFull, null); },
        isDirty: isSenderImageOptionDirty,
        onSave: saveSenderImageOption,
        onDiscard: discardSenderImageOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isSenderImageEnabled,
            onToggle: onSenderImageToggle,
        },
        order: 5 /* SenderImage */,
        workloads: 1 /* Mail */,
    },
};
export default SenderImageOption;
//# sourceMappingURL=SenderImageOption.js.map